import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, buildWaLink, openWa } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { MessageCircle } from "lucide-react";

export const NUDGE_LABELS = { no_leads: "No lead entry today", followups: "Overdue follow-ups", low_performance: "Low performance", warning: "Formal warning", appreciation: "Appreciation", custom: "Custom message" };

// emp: { id | employee_id, name }
export const NudgeDialog = ({ emp, onClose }) => {
  const [template, setTemplate] = useState("no_leads");
  const [data, setData] = useState(null);
  const eid = emp?.employee_id || emp?.id;
  useEffect(() => {
    if (!eid) return;
    api.get(`/admin/employees/${eid}/nudge?template=${template}`).then(({ data }) => setData(data)).catch(() => toast.error("Could not load message"));
  }, [eid, template]);
  const send = () => {
    if (!data?.phone) { toast.error("No mobile number saved for this employee — add it under Employees."); return; }
    openWa(buildWaLink(data.phone, data.message));
    onClose();
  };
  return (
    <Dialog open={!!emp} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="nudge-dialog">
        <DialogHeader><DialogTitle className="font-heading text-2xl">WhatsApp {emp?.name}</DialogTitle></DialogHeader>
        {data && <div className="space-y-3">
          <Select value={template} onValueChange={setTemplate}><SelectTrigger data-testid="nudge-template"><SelectValue /></SelectTrigger><SelectContent>{Object.entries(NUDGE_LABELS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select>
          <Textarea rows={6} value={data.message} onChange={(e) => setData({ ...data, message: e.target.value })} data-testid="nudge-message" />
          <p className="text-xs text-muted-foreground">{data.leads_today} lead{data.leads_today === 1 ? "" : "s"} entered today · to {data.phone || "no number saved"}</p>
          <Button className="w-full rounded-full bg-[#25D366] hover:bg-[#1da851] text-white" onClick={send} data-testid="nudge-send"><MessageCircle className="h-4 w-4 mr-1" /> Send on WhatsApp</Button>
        </div>}
      </DialogContent>
    </Dialog>
  );
};
